import axios from 'axios';
import { ProgressResponse } from 'src/models/progress';

import { BASE_URL } from './config';
const ENDPOINT = '/api/employee';

export function getProgress(studentId: string) {
  const TOKEN = sessionStorage.getItem('Token');

  const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + TOKEN,
    },
  });

  return apiClient.get<ProgressResponse>(`${ENDPOINT}/${studentId}/progress`);
}
